export default __webpack_public_path__ + "static/green_bg-594ab6a0df5f251c6b3a01fc0f3ad7c3.png";